export function ArtifactTitle({ title, fallback }: { title: string | null; fallback: string }) {
  const fullTitle = title || fallback;
  return (
    <span className="field-value field-value-clamp2" title={fullTitle}>
      {fullTitle}
    </span>
  );
}
